import { Form } from 'dash-ui';
import styled from 'styled-components';

export const StyledForm = styled(Form)`
  box-sizing: border-box;
`;
